import { NgModule } from '@angular/core';
import { BadgeComponent } from './badge.component';

@NgModule({
  declarations: [BadgeComponent],
  exports: [BadgeComponent],
})
export class BadgeModule {}
